import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';
import { VexPopoverService } from '@vex/components/vex-popover/vex-popover.service';
import { ToolbarUserDropdownComponent } from './toolbar-user-dropdown/toolbar-user-dropdown.component';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { inject } from '@angular/core';
import { AuthService , User } from 'src/service/auth/auth.service';
@Component({
  selector: 'vex-toolbar-user',
  templateUrl: './toolbar-user.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatRippleModule, MatIconModule]
})
export class ToolbarUserComponent implements OnInit {
  dropdownOpen: boolean = false;
  private authService: AuthService
  public userFullName$: string
  private userId: number
  public userImageUrl$: string
  public userTitle$: string


  constructor(
    private popover: VexPopoverService,
    private cd: ChangeDetectorRef
  ) {
      this.userFullName$ = ""
      this.userId = 0
      this.userFullName$ = ""
      this.userImageUrl$ = ""
      this.userTitle$ = ""
        this.authService = inject(AuthService);
  }

  ngOnInit() {
        var user = this.authService.loggedInUser
        this.userFullName$ = user.fullName + "(" + user.title + ")";
        this.userId = user.id;
        this.userImageUrl$ = "../../../../assets/img/avatars/" + this.userId + ".jpg";
        this.userTitle$ = user.title;
  }

  showPopover(originRef: HTMLElement) {
    this.dropdownOpen = true;
    this.cd.markForCheck();

    const popoverRef = this.popover.open({
      content: ToolbarUserDropdownComponent,
      origin: originRef,
      offsetY: 12,
      position: [
        {
          originX: 'center',
          originY: 'top',
          overlayX: 'center',
          overlayY: 'bottom'
        },
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top'
        }
      ]
    });

    popoverRef.afterClosed$.subscribe(() => {
      this.dropdownOpen = false;
      this.cd.markForCheck();
    });
  }
}
